/**
 * Modular What's New entries for the "utilities" module (Rezsi nyilvántartás): monthly submission
 * windows. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const utilitiesEntries = [
  {
    id: 'utilities-submission-window-2026-10',
    module: 'utilities',
    routes: ['UtilityHomeScreen', 'UtilityProvidersScreen', 'UtilityProviderDetailScreen'],
    date: '2026-10-19',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "🗓️ Submission windows for utility bills",
      hu: "🗓️ Rezsi leadás időszakkal, nem csak fix nappal",
      de: "🗓️ Abgabezeiträume für Nebenkosten",
      cn: "🗓️ 水电费提交时段",
      ro: "🗓️ Intervale de transmitere pentru utilități",
      svn: "🗓️ Obdobja oddaje za stroške komunalnih storitev",
    },
    body: {
      en: "Utility readings and bills used to have a single fixed due day, even when the provider accepts them over several days. Providers can now have a monthly submission window, for example the 1st to the 5th. The provider list and details show the window and its deadline, mark it as open while it runs, and overdue is counted from the deadline.",
      hu: "A rezsi leadásnak eddig csak egy fix napja lehetett, akkor is, ha a szolgáltató több napon át fogadja az adatokat. Mostantól havi leadási időszak is megadható, például 1. és 5. között. A szolgáltatók listája és részletei mutatják az időszakot és a határidőt, nyitva jelzik, amíg tart, a lejártságot pedig a határidőtől számoljuk.",
      de: "Für Zählerstände und Rechnungen gab es bisher nur einen festen Fälligkeitstag, auch wenn der Anbieter sie über mehrere Tage annimmt. Jetzt kann ein monatlicher Abgabezeitraum festgelegt werden, zum Beispiel vom 1. bis zum 5. Anbieterliste und Details zeigen den Zeitraum samt Frist, markieren ihn als offen, solange er läuft, und die Überfälligkeit wird ab der Frist gezählt.",
      cn: "以前抄表和账单只能设置一个固定的到期日，即使供应商会连续几天接收。现在可以设置每月的提交时段，例如每月 1 日至 5 日。供应商列表和详情会显示该时段及截止日期，在时段内标记为进行中，逾期则从截止日期起计算。",
      ro: "Citirile și facturile aveau până acum o singură zi fixă de scadență, chiar dacă furnizorul le primește mai multe zile. Acum se poate seta un interval lunar de transmitere, de exemplu între 1 și 5. Lista și detaliile furnizorilor afișează intervalul și termenul limită, îl marchează ca deschis cât timp este activ, iar întârzierea se numără de la termenul limită.",
      svn: "Odčitki in računi so imeli doslej en sam fiksen dan zapadlosti, tudi če jih ponudnik sprejema več dni. Zdaj je mogoče nastaviti mesečno obdobje oddaje, na primer od 1. do 5. Seznam ponudnikov in podrobnosti prikazujejo obdobje z rokom, ga med trajanjem označijo kot odprto, zamuda pa se šteje od roka.",
    },
  },
];

export default utilitiesEntries;
